import { useEffect, useState } from "react"
import _ from 'lodash'
import { Box, Popover, TextField, Typography, MenuItem } from '@material-ui/core'
import useStyles from "./style"
import { Cards } from '../../../elements'
import { Breadcrumb, AppButton, Loader } from '../../../Components'
import { KeyboardArrowDown } from '@material-ui/icons'
import moment from 'moment-timezone'
import CustomDatePicker from '../../../elements/DatePicker'
import { developerHubService } from '../../../Services/DeveloperHubService'
import TableContents from './tableData'
import { Headings, SORTORDER } from './constants'
import { connect } from "react-redux"
import { accountService } from '../../../Services/AccountService/AccountService'
import DowntimeForm from './DowntimeForm'

const UsageAndMetrics = (props) => {
  const timezone = 'GMT'
  const initialTime = moment().tz(timezone)
  const marginLeft = '10px'
  const [accountId, setAccountId] = useState('')
  const [accountName, setAccountName] = useState()
  const CalendarFormat = "MM-DD-YYYY"
  const [startCalendarOpen, setStartCalendarOpen] = useState(false)
  const [endCalendarOpen, setendCalendarOpen] = useState(false)
  const [pageNo, setPageNo] = useState(0)
  const [pageSize, setPageSize] = useState(15)
  const [sortBy, setSortBy] = useState('totalRequests')
  const [sortOrder, setSortOrder] = useState('descending')
  const [tableContents, setTableContents] = useState([])
  const [tableHeadings, setTableHeadings] = useState(Headings)
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const [count, setCount] = useState(1)
  const [anchorEl, setAnchorEl] = useState(null)
  const [totalItems, setTotalItems] = useState(0)
  const [accountsList, setAccountsList] = useState([])
  const { currentUser } = props
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [downtimeForm, setDowntimeForm] = useState(false)

  let loginAccountName = props.accountId

  useEffect(() => {
    if (props.isSuperAdmin) {
      getAllAccounts()
    } else {
      setAccountId(currentUser.account_company_name)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const startOfQuarter = moment().startOf('quarter').toDate()
    const yesterday = moment().subtract(1, 'day').toDate()

    setStartDate(startOfQuarter)
    setEndDate(yesterday)
  }, [])

  const getAllAccounts = () => {
    setLoading(true)
    accountService.getAllAccounts(currentUser.account_id)
      .then((response) => {
        setAccountsList(response)
        setLoading(false)
      }).catch((error) => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (startDate !== '' && endDate !== '' && accountId !== '') {
      setLoading(true)
      developerHubService.getApiMetrics(pageNo, pageSize, moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"), sortOrder, sortBy, accountId, loginAccountName)
        .then((data) => {
          setTableContents(data)
          setTotalItems(data.totalCount)
          setLoading(false)
        })
        .catch(() => {
          setLoading(false)
        })
    }
  }, [pageNo, pageSize, sortOrder, sortBy, accountId, startDate, endDate])


  const handleSortChange = (header) => {
    const modifiedObj = _.cloneDeep(tableHeadings)
    modifiedObj.forEach((obj, index) => {
      if (obj.id === header) {
        modifiedObj[index].sortOrder = obj.sortOrder === SORTORDER.ASC ? SORTORDER.DESC : SORTORDER.ASC
      } else {
        modifiedObj[index].sortOrder = SORTORDER.ASC
      }
    })
    const selectedObj = modifiedObj.find((obj) => header === obj.id)
    const selectedTypeAsc = selectedObj.sortOrder === SORTORDER.ASC ? SORTORDER.ASC : SORTORDER.DESC
    setSortBy(header)
    setSortOrder(selectedTypeAsc)
    setPageNo(0)
    setTableHeadings(modifiedObj)
  }

  const handleChangePage = (newPage) => {
    setPageNo(newPage - 1)
  }

  useEffect(() => {
    let curCount = Math.ceil(totalItems / pageSize)
    setCount(curCount)
    setPageNo(0)
  }, [pageSize])

  useEffect(() => {
    let curCount = Math.ceil(totalItems / pageSize)
    setCount(curCount)
  }, [totalItems])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleDone = (data, obj) => {
    const m = moment(data.date)
    const onlyDate = moment.tz(
      {
        year: m.year(),
        month: m.month(),  
        day: m.date(),
        hour: 12
      },
      timezone
    ).toDate()
    if (obj === "startDate") {
      setStartDate(onlyDate)
      setStartCalendarOpen(false)
    } else {
      setEndDate(onlyDate)
      setendCalendarOpen(false)
    }
  }

  const handleStartDateClick = () => {
    setStartCalendarOpen(true)
    setEndDate('')
  }

  const handleEndDateClick = () => {
    setendCalendarOpen(true)
  }

  const openPopover = Boolean(anchorEl)
  const id = openPopover ? 'simple-popover' : undefined

  const RenderSubHeaderContents = () => {
    return (
      <>
        <Box ml={marginLeft}>
          <TextField
            id="startDate"
            name="startDate"
            label='Select Start Date'
            onClick={handleStartDateClick}
            value={startDate && moment(startDate).format("YYYY-MM-DD")}
          />
          <Box className={classes.dateInput}>
            {startCalendarOpen && (
              <CustomDatePicker
                value={startDate || null}
                name={startDate}
                minDate={moment.tz("2025-10-01", "YYYY-MM-DD", timezone).hour(12).toDate()}
                maxDate={initialTime.clone().subtract(2, 'days').endOf('day').toDate()}
                format={CalendarFormat}
                timezone={timezone}
                handleCancel={() => setStartCalendarOpen(false)}
                handleDone={((data) => handleDone(data, "startDate"))}
              />)}
          </Box>
        </Box>
        <Box ml={marginLeft}>
          <TextField
            id="endDate"
            name="endDate"
            label='Select End Date'
            value={endDate && moment(endDate).format("YYYY-MM-DD")}
            onClick={handleEndDateClick}
            disabled={startDate === ''}
          />
          <Box className={classes.dateInput}>
            {endCalendarOpen && (
              <CustomDatePicker
                name={endDate}
                value={endDate || null}
                minDate={startDate ? moment(startDate).clone().startOf('day').toDate() : null}
                maxDate={initialTime.clone().subtract(2, 'days').endOf('day').toDate()}
                format={CalendarFormat}
                timezone={timezone}
                handleCancel={() => setendCalendarOpen(false)}
                handleDone={((data) => handleDone(data, "endDate"))}
              />)}
          </Box>
        </Box>
        {!props.isSuperAdmin && <Box width='200px'></Box>}
      </>
    )
  }
  return (
    <Box>
      <Breadcrumb value={[{ 'Developer Hub': '/developer' }, { 'API Usage': '/developer/api-usage-and-metrics' }]} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>API Usage and Metrics</Typography>
        <Box className={classes.SubheaderWrapper}>
          <RenderSubHeaderContents />
          <Loader loading={loading} />
          {props.isSuperAdmin && 
          <>
            <Box ml={marginLeft} >
              <AppButton className={classes.buttons} text={
                <Box display="flex" justifyContent="space-between" alignItems="center" >
                  <Box className={classes.paperText}>{accountName ? `Account | ${accountName}` : 'SELECT ACCOUNT'}</Box>
                  <KeyboardArrowDown />
                </Box>
              } onClick={handleClick} minHeight="39.5px" />
              <Popover
                open={openPopover}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                classes={{ paper: classes.paper }}
              >
                {accountsList && accountsList.map(account => (
                  <MenuItem key={account.id} value={account.id} onClick={() => { setAccountId(account.company_name); setAccountName(account.company_name); handleClose() }}>
                    <Box display="flex" justifyContent="space-between" width="100%">
                      <Box component="span">
                        {account.company_name}
                      </Box>
                    </Box>
                  </MenuItem>
                ))}
              </Popover>
            </Box>
            <Box ml={marginLeft}>
              <AppButton fill={true} text="Add Downtime" className={classes.buttons} minHeight="39.5px" onClick={()=>setDowntimeForm(prev => !prev)}/>
              <DowntimeForm open={downtimeForm} setDowntimeForm={setDowntimeForm} initialTime={initialTime} CalendarFormat={CalendarFormat} timezone={timezone} accountsList={accountsList}/>
            </Box>
          </>}
        </Box>
      </Box>
      <Cards className={classes.cardWrapper}>
        <TableContents
          tableHeadings={tableHeadings}
          tableContents={tableContents}
          pageSize={pageSize}
          setPageSize={setPageSize}
          setPageNo={setPageNo}
          count={count}
          pageNo={pageNo}
          handleChangePage={handleChangePage}
          sortOrder={sortOrder}
          sortBy={sortBy}
          handleSortChange={handleSortChange}
        />
      </Cards>
      <Box className={classes.headerWrapper} >
        <span style={{marginRight: '4px', color: '#F37320'}}>Note:</span>
        <span style={{fontSize: '14px', fontStyle: 'italic'}}> 
          These metrics do not reflect failed requests resulting from events such as scheduled maintenance, planned site outages, unavailability of third‑party cloud services that support API functionality, client‑side issues, or other force majeure events and are provided for reference purposes only. Notwithstanding the foregoing, Enphase reserves the right to update these metrics in response to certain events materially impacting the service.
        </span> 
       </Box>
    </Box >
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin, isViewOnly, accountId } = auth
  return { currentUser, isSuperAdmin, isViewOnly, accountId }
}

export default connect(mapStateToProps, {})(UsageAndMetrics)